import { render } from "./CharacterDetail.vue?vue&type=template&id=94909798"
import script from "./CharacterDetail.vue?vue&type=script&lang=js"
export * from "./CharacterDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__